import {
  AddConfigExternalCollaboratorRequest,
  UpdateConfigExternalCollaboratorRequest,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsExternalCollaboratorsService = {
  async add(body: AddConfigExternalCollaboratorRequest): Promise<void> {
    await httpClient.post("v1/config/external/collaborators", body);
  },
  async update(
    collaboratorId: number,
    body: UpdateConfigExternalCollaboratorRequest,
  ): Promise<void> {
    await httpClient.patch(
      `v1/config/external/collaborators/${collaboratorId}`,
      body,
    );
  },
  async delete(collaboratorId: number): Promise<void> {
    await httpClient.delete(
      `v1/config/external/collaborators/${collaboratorId}`,
    );
  },
};

export default ConfigurationsExternalCollaboratorsService;
